// extracted by mini-css-extract-plugin
export default {"noOperator":"_5PWaU15PrMGF3JejWT6QsT"};